import { WebshopProduct } from '@cldsystems/ws-api-client';
import {
  getEffectiveCustomerPrice,
  type PriceFilterContext,
} from '@/utils/effective-product-price';

export const isPriceInRange = (price: number, range: string) => {
  const [min, max] = range
    .split('-')
    .map(value => (value === 'infinity' ? Infinity : parseFloat(value)));
  return price >= min && price <= max;
};

export const isProductInPriceRanges = (
  product: WebshopProduct,
  priceRanges: string[],
  ctx?: PriceFilterContext | null,
) => {
  const effective = getEffectiveCustomerPrice(product, ctx);
  return priceRanges.some(range => isPriceInRange(effective, range));
};

export const doesProductMatchFilter = (
  product: WebshopProduct,
  key: string,
  filterValues: string[],
) => {
  return product.categoryAttributeGroups.some(group =>
    group.options.some(option => {
      const paramKey = option.key.charAt(0).toLowerCase() + option.key.slice(1);
      if (paramKey !== key) return false;

      const normalizedValues =
        Array.isArray(option.values) && option.values.length > 0
          ? option.values
          : 'value' in option && option.value != null && String(option.value).length > 0
            ? [String(option.value)]
            : [];

      return normalizedValues.some(value => filterValues.includes(value));
    }),
  );
};
